enum EVariantArticleKit {
  SEPARATE_KIT = 'separate_kit',
  MISSING = 'missing',
}

export default EVariantArticleKit;
